import React from 'react'

const Manual_tipo_de_orden = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     DELIVERECT - Tipo de Orden
     </h2>
     <iframe
          src="https://scribehow.com/embed/DELIVERECT__Tipo_de_Orden__FtRfhqXKRvmmxo0u6U4tHw?as=scrollable"
          className="scribe-iframe-deliverect-1"
          width="100%"
          height="3300"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_tipo_de_orden